(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5784],{

/***/ 60362:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ FederatedButtons; }
});

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./store/reducers/user.js
var user = __webpack_require__(64727);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@aws-amplify/auth/dist/esm/providers/cognito/apis/signInWithRedirect.mjs + 17 modules
var signInWithRedirect = __webpack_require__(79161);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./components/atomic/FederatedButtons/federated-buttons.module.scss
var federated_buttons_module = __webpack_require__(13144);
var federated_buttons_module_default = /*#__PURE__*/__webpack_require__.n(federated_buttons_module);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Button/Button.tsx
var Button_Button = __webpack_require__(27532);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/atomic/FederatedButtons/FederatedButtons.js









var Buttons = function(param) {
    var savePage = param.savePage, toggleSocialLogin = param.toggleSocialLogin, _signUp = param.signUp, signUp = _signUp === void 0 ? false : _signUp, _googleOnly = param.googleOnly, googleOnly = _googleOnly === void 0 ? false : _googleOnly, _facebookOnly = param.facebookOnly, facebookOnly = _facebookOnly === void 0 ? false : _facebookOnly, _mobileVersion = param.mobileVersion, mobileVersion = _mobileVersion === void 0 ? false : _mobileVersion;
    var router = (0,next_router.useRouter)();
    var google = function(e) {
        e.preventDefault();
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "social-".concat(signUp ? "sign-up" : "login"),
            label: "google"
        });
        savePage(router.asPath);
        toggleSocialLogin();
        (0,signInWithRedirect/* signInWithRedirect */.F)({
            provider: "Google"
        });
    };
    var facebook = function(e) {
        e.preventDefault();
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "social-".concat(signUp ? "sign-up" : "login"),
            label: "facebook"
        });
        savePage(router.asPath);
        toggleSocialLogin();
        (0,signInWithRedirect/* signInWithRedirect */.F)({
            provider: "Facebook"
        });
    };
    var bothButtonsAvailable = !googleOnly && !facebookOnly;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((federated_buttons_module_default()).container, " ").concat(mobileVersion ? (federated_buttons_module_default())["mobile-version-container"] : ""),
        children: [
            (bothButtonsAvailable || googleOnly) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                label: "Continue with Google",
                onClick: google,
                size: system/* Size.Large */.$u.Large,
                hierarchy: Button_Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray
            }),
            (bothButtonsAvailable || facebookOnly) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                label: "Continue with Facebook",
                onClick: facebook,
                size: system/* Size.Large */.$u.Large,
                hierarchy: Button_Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray
            })
        ]
    });
};
Buttons.propTypes = {
    savePage: (prop_types_default()).func.isRequired,
    toggleSocialLogin: (prop_types_default()).func.isRequired,
    googleOnly: (prop_types_default()).bool,
    facebookOnly: (prop_types_default()).bool,
    signUp: (prop_types_default()).bool,
    mobileVersion: (prop_types_default()).bool
};

;// CONCATENATED MODULE: ./components/atomic/FederatedButtons/index.js



var MapDispatchToProps = function(dispatch) {
    return {
        savePage: function(pageUrl) {
            return dispatch((0,user/* storeRedirectUrl */.Nt)(pageUrl));
        },
        toggleSocialLogin: function() {
            return dispatch((0,user/* storeUsedSocialLogin */.F8)(true));
        }
    };
};
var FederatedButtons = (0,es/* connect */.$j)(undefined, MapDispatchToProps)(Buttons);


/***/ }),

/***/ 29171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_AuthenticationProcess; }
});

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(80969);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(69779);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-awesome-reveal/dist/index.js + 1 modules
var dist = __webpack_require__(81277);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./components/views/AuthenticationProcess/authentication-process.module.scss
var authentication_process_module = __webpack_require__(55806);
var authentication_process_module_default = /*#__PURE__*/__webpack_require__.n(authentication_process_module);
// EXTERNAL MODULE: ./components/atomic/FederatedButtons/index.js + 1 modules
var FederatedButtons = __webpack_require__(60362);
// EXTERNAL MODULE: ./components/styleguide/Button/index.ts
var Button = __webpack_require__(96732);
// EXTERNAL MODULE: ./components/styleguide/Link/index.ts + 1 modules
var Link = __webpack_require__(63383);
// EXTERNAL MODULE: ./lib/constants.js + 1 modules
var constants = __webpack_require__(99280);
// EXTERNAL MODULE: ./lib/hooks/useExperiment.ts
var useExperiment = __webpack_require__(46389);
// EXTERNAL MODULE: ./lib/utilities/vehicle.js
var vehicle = __webpack_require__(13732);
// EXTERNAL MODULE: ./types/system.ts
var system = __webpack_require__(16693);
;// CONCATENATED MODULE: ./components/views/AuthenticationProcess/AuthenticationProcess.js
















var LogInForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2580), __webpack_require__.e(6310), __webpack_require__.e(7385), __webpack_require__.e(2937)]).then(__webpack_require__.bind(__webpack_require__, 52937));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52937)
            ];
        }
    },
    ssr: false
});
var SignUpForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2580), __webpack_require__.e(6310), __webpack_require__.e(8835), __webpack_require__.e(1338)]).then(__webpack_require__.bind(__webpack_require__, 41338));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41338)
            ];
        }
    },
    ssr: false
});
var VerifyFormWrapper = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2580), __webpack_require__.e(6310), __webpack_require__.e(8835), __webpack_require__.e(6938)]).then(__webpack_require__.bind(__webpack_require__, 26938));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26938)
            ];
        }
    },
    ssr: false
});
var ForgotPasswordForm = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2580), __webpack_require__.e(6310), __webpack_require__.e(1791)]).then(__webpack_require__.bind(__webpack_require__, 71791));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71791)
            ];
        }
    },
    ssr: false
});
var UserProfileBuilder = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2580), __webpack_require__.e(6310), __webpack_require__.e(7600)]).then(__webpack_require__.bind(__webpack_require__, 57600));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57600)
            ];
        }
    },
    ssr: false
});
var AiIntro = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8298)]).then(__webpack_require__.bind(__webpack_require__, 98298));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98298)
            ];
        }
    },
    ssr: false
});
var AuthenticationProcess = function(param) {
    var initialStatus = param.initialStatus, hideHeaders = param.hideHeaders, isEnquiry = param.isEnquiry, storeIsUserAuthenticated = param.storeIsUserAuthenticated, storeUserName = param.storeUserName, garagePage = param.garagePage, username = param.username, getAccountInfo = param.getAccountInfo, authPage = param.authPage, visitorKey = param.visitorKey, isAuthenticated = param.isAuthenticated, _setUserState = param.setUserState, setUserState = _setUserState === void 0 ? function() {} : _setUserState, _isModal = param.isModal, isModal = _isModal === void 0 ? false : _isModal, setStatusHistory = param.setStatusHistory, shouldShowBackButton = param.shouldShowBackButton, getPreviousStatus = param.getPreviousStatus, _includeUserProfileBuilder = param.includeUserProfileBuilder, includeUserProfileBuilder = _includeUserProfileBuilder === void 0 ? true : _includeUserProfileBuilder, postAnalyticsEvent = param.postAnalyticsEvent, hideModal = param.hideModal, _hideSecondaryActions = param.hideSecondaryActions, hideSecondaryActions = _hideSecondaryActions === void 0 ? false : _hideSecondaryActions;
    var mobileVersion = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 992px)"
    });
    var ref = (0,_sliced_to_array/* default */.Z)((0,useExperiment/* useExperiment */.a)(), 1), experimentGroup = ref[0];
    var ref1 = (0,react.useState)(initialStatus ? initialStatus : constants/* STATUS_LOGIN */.NN), status = ref1[0], setStatus = ref1[1];
    var ref2 = (0,react.useState)(""), userEmail = ref2[0], setUserEmail = ref2[1];
    var ref3 = (0,react.useState)(""), userPassword = ref3[0], setUserPassword = ref3[1];
    var ref4 = (0,react.useState)(""), userFirstName = ref4[0], setUserFirstName = ref4[1];
    var ref5 = (0,react.useState)(""), userLastName = ref5[0], setUserLastName = ref5[1];
    var ref6 = (0,react.useState)(false), isLoading = ref6[0], setIsLoading = ref6[1];
    var ref7 = (0,react.useState)(""), error = ref7[0], setError = ref7[1];
    var ref8 = (0,react.useState)(""), info = ref8[0], setInfo = ref8[1];
    (0,react.useEffect)(function() {
        setUserState({
            email: userEmail
        });
    }, [
        setUserState,
        status,
        userEmail
    ]);
    var changeStatus = function(newStatus) {
        (0,vehicle/* addToDataLayer */.Bk)({
            event: "authentication_step_change",
            action: "".concat(status, " to ").concat(newStatus)
        });
        if (hideModal) {
            (0,vehicle/* addToDataLayer */.Bk)({
                event: "modal-view",
                action: "/" + newStatus.toLowerCase().replace("_", "-")
            });
        }
        setStatus(newStatus);
        if (setStatusHistory) {
            setStatusHistory(function(prev) {
                return (0,_to_consumable_array/* default */.Z)(prev).concat([
                    newStatus
                ]);
            });
        }
    };
    var handleBackButtonClick = function() {
        setStatus(getPreviousStatus());
    };
    var renderForm = function() {
        var commonProps = {
            setStatus: changeStatus,
            status: status,
            isEnquiry: isEnquiry,
            garagePage: garagePage,
            storeUserName: storeUserName,
            username: username,
            setUserEmail: setUserEmail,
            userEmail: userEmail,
            setUserPassword: setUserPassword,
            userPassword: userPassword,
            setUserFirstName: setUserFirstName,
            setUserLastName: setUserLastName,
            userFirstName: userFirstName,
            userLastName: userLastName,
            isLoading: isLoading,
            setIsLoading: setIsLoading,
            setError: setError,
            setInfo: setInfo,
            getAccountInfo: getAccountInfo,
            authPage: authPage,
            visitorKey: visitorKey,
            storeIsUserAuthenticated: storeIsUserAuthenticated,
            mobileVersion: mobileVersion,
            hideHeaders: hideHeaders,
            includeUserProfileBuilder: includeUserProfileBuilder,
            experimentGroup: experimentGroup,
            postAnalyticsEvent: postAnalyticsEvent,
            hideModal: hideModal,
            hideSecondaryActions: hideSecondaryActions
        };
        switch(status){
            case constants/* STATUS_AI_INTRO */.uR:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AiIntro, (0,_object_spread/* default */.Z)({}, commonProps));
            case constants/* STATUS_REGISTER */.aJ:
            case constants/* STATUS_PRE_REGISTER */.k_:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SignUpForm, (0,_object_spread/* default */.Z)({}, commonProps));
            case constants/* STATUS_LOGIN */.NN:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LogInForm, (0,_object_spread/* default */.Z)({}, commonProps));
            case constants/* STATUS_GOOGLE_LOGIN */.fw:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (authentication_process_module_default())["social-wrap"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "You've previously logged into LeaseLoco with your Google account."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FederatedButtons/* FederatedButtons */.O, {
                                googleOnly: true
                            })
                        })
                    ]
                });
            case constants/* STATUS_FACEBOOK_LOGIN */.Z2:
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (authentication_process_module_default())["social-wrap"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "You've previously logged into LeaseLoco with your Facebook account."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FederatedButtons/* FederatedButtons */.O, {
                                facebookOnly: true
                            })
                        })
                    ]
                });
            case constants/* STATUS_VERIFY */.rn:
            case constants/* STATUS_VERIFY_FROM_SIGN_UP */.bX:
            case constants/* STATUS_ALREADY_VERIFIED */.iH:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(VerifyFormWrapper, (0,_object_spread/* default */.Z)({}, commonProps));
            case constants/* STATUS_FORGOT_PASSWORD */.wc:
            case constants/* STATUS_PASSWORD_RESET_EMAIL_SENT */.MO:
            case constants/* STATUS_NEW_PASSWORD */.Xz:
            case constants/* STATUS_PASSWORD_COMPLETE */.v:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ForgotPasswordForm, (0,_object_spread/* default */.Z)({}, commonProps));
            case constants/* STATUS_GATHER_MOBILE_NUMBER */.Yf:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserProfileBuilder, (0,_object_spread/* default */.Z)({}, commonProps));
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LogInForm, (0,_object_spread/* default */.Z)({}, commonProps));
        }
    };
    if (isAuthenticated && authPage) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (authentication_process_module_default())["logged-in"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            children: "You're already logged in."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Check out our hot deals"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* InternalLink */.h, {
                    hasBackground: true,
                    hasPadding: true,
                    href: "/car-leasing/search",
                    hierarchy: Button/* ButtonHierarchy.Filled */.B.Filled,
                    size: system/* Size.Medium */.$u.Medium,
                    children: "Continue"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((authentication_process_module_default())["form-container"], " ").concat(isModal && status !== constants/* STATUS_AI_INTRO */.uR ? (authentication_process_module_default()).modal : "", " ").concat(isEnquiry ? (authentication_process_module_default())["form-container--enquiry"] : "", " ").concat(hideHeaders ? (authentication_process_module_default())["hide-headers"] : ""),
        children: [
            shouldShowBackButton && isModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                size: system/* Size.Small */.$u.Small,
                onClick: handleBackButtonClick,
                className: (authentication_process_module_default())["back-button"],
                hierarchy: Button/* ButtonHierarchy.BezeledGray */.B.BezeledGray,
                icon: "ChevronLeft"
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (authentication_process_module_default())["error-message"],
                    role: "alert",
                    children: error
                })
            }),
            renderForm(),
            info && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Fade */.pT, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: (authentication_process_module_default())["info-message"],
                    role: "alert",
                    children: info
                })
            })
        ]
    });
};
/* harmony default export */ var AuthenticationProcess_AuthenticationProcess = (AuthenticationProcess);

// EXTERNAL MODULE: ./store/actions/event.js
var actions_event = __webpack_require__(61748);
// EXTERNAL MODULE: ./store/reducers/user.js
var user = __webpack_require__(64727);
// EXTERNAL MODULE: ./store/selectors/user.js
var selectors_user = __webpack_require__(15433);
;// CONCATENATED MODULE: ./components/views/AuthenticationProcess/index.js





var MapStateToProps = function(state) {
    return {
        visitorKey: (0,selectors_user/* selectUsersVisitorKey */.z_)(state),
        username: (0,selectors_user/* selectUsersUsername */.xd)(state),
        isAuthenticated: (0,selectors_user/* selectIsAuthenticated */.vN)(state)
    };
};
var MapDispatchToProps = function(dispatch) {
    return {
        storeIsUserAuthenticated: function(isAuthenticated) {
            return dispatch((0,user/* storeIsUserAuthenticated */.Nr)(isAuthenticated));
        },
        storeUserName: function(name) {
            return dispatch((0,user/* storeUserName */.b4)(name));
        },
        getAccountInfo: function() {
            return dispatch((0,user/* getAccountInfo */.fn)());
        },
        postAnalyticsEvent: function(data) {
            return dispatch((0,actions_event/* postAnalyticsEvent */.gR)(data));
        }
    };
};
var views_AuthenticationProcess_AuthenticationProcess = (0,es/* connect */.$j)(MapStateToProps, MapDispatchToProps)(AuthenticationProcess_AuthenticationProcess);
/* harmony default export */ var views_AuthenticationProcess = (views_AuthenticationProcess_AuthenticationProcess);


/***/ }),

/***/ 13144:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"federated-buttons_container__ImsX_","mobile-version-container":"federated-buttons_mobile-version-container__GruES","phAnimation":"federated-buttons_phAnimation__ftaLL"};

/***/ }),

/***/ 55806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form-container":"authentication-process_form-container__rkvpO","form-container--enquiry":"authentication-process_form-container--enquiry__xzxY2","modal":"authentication-process_modal__Np1AX","form":"authentication-process_form__nKQXi","row":"authentication-process_row__RDGIw","inputs":"authentication-process_inputs__8FblL","form-group":"authentication-process_form-group__ZZkSD","form-multi":"authentication-process_form-multi__Cs439","form-input":"authentication-process_form-input__i8uv6","form-input--error":"authentication-process_form-input--error__zB7d2","error":"authentication-process_error__6XBF6","form-row":"authentication-process_form-row__h34jU","graphic":"authentication-process_graphic__vJoRC","newsletter-form-header":"authentication-process_newsletter-form-header__Bb5Wr","wrapped-toggle":"authentication-process_wrapped-toggle__rOVRM","terms":"authentication-process_terms__w5Nz0","form-header":"authentication-process_form-header__5lU_O","hide-headers":"authentication-process_hide-headers__oIar5","back-button":"authentication-process_back-button__Pix_F","info-box":"authentication-process_info-box__dAitX","password-toggle":"authentication-process_password-toggle__bumPj","submit-button":"authentication-process_submit-button__hqIY_","success-wrap":"authentication-process_success-wrap__xPN1J","social-wrap":"authentication-process_social-wrap__NDY_E","error-message":"authentication-process_error-message__x0O9M","info-message":"authentication-process_info-message__FxKtw","verify-title":"authentication-process_verify-title__2nb96","subtext":"authentication-process_subtext__txbq9","options-divider":"authentication-process_options-divider__qcA_H","text-link":"authentication-process_text-link__ezqM6","text-link-button":"authentication-process_text-link-button__Ryb6D","button":"authentication-process_button__L2wg8","logged-in":"authentication-process_logged-in__LegML","auth-form":"authentication-process_auth-form__G84d8","two-column-row":"authentication-process_two-column-row__dAEqm","tel":"authentication-process_tel__F7k0G","ai-intro":"authentication-process_ai-intro__BuM7B","carousel-container":"authentication-process_carousel-container__BjKbF","media-card":"authentication-process_media-card__fYzE1","image":"authentication-process_image__WBCtH","content":"authentication-process_content__bsxVn","cta":"authentication-process_cta__QxwlS","phAnimation":"authentication-process_phAnimation__AbQFh"};

/***/ }),

/***/ 53136:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AL": function() { return /* binding */ AuthErrorStrings; },
/* harmony export */   "By": function() { return /* binding */ validationErrorMap; },
/* harmony export */   "kq": function() { return /* binding */ AuthErrorCodes; }
/* harmony export */ });
/* harmony import */ var _errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55227);


// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const validationErrorMap = {
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyChallengeResponse */ .X.EmptyChallengeResponse]: {
        message: 'challengeResponse is required to confirmSignIn',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyConfirmResetPasswordUsername */ .X.EmptyConfirmResetPasswordUsername]: {
        message: 'username is required to confirmResetPassword',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyConfirmSignUpCode */ .X.EmptyConfirmSignUpCode]: {
        message: 'code is required to confirmSignUp',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyConfirmSignUpUsername */ .X.EmptyConfirmSignUpUsername]: {
        message: 'username is required to confirmSignUp',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyConfirmResetPasswordConfirmationCode */ .X.EmptyConfirmResetPasswordConfirmationCode]: {
        message: 'confirmationCode is required to confirmResetPassword',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyConfirmResetPasswordNewPassword */ .X.EmptyConfirmResetPasswordNewPassword]: {
        message: 'newPassword is required to confirmResetPassword',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyResendSignUpCodeUsername */ .X.EmptyResendSignUpCodeUsername]: {
        message: 'username is required to confirmSignUp',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyResetPasswordUsername */ .X.EmptyResetPasswordUsername]: {
        message: 'username is required to resetPassword',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptySignInPassword */ .X.EmptySignInPassword]: {
        message: 'password is required to signIn',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptySignInUsername */ .X.EmptySignInUsername]: {
        message: 'username is required to signIn',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptySignUpPassword */ .X.EmptySignUpPassword]: {
        message: 'password is required to signUp',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptySignUpUsername */ .X.EmptySignUpUsername]: {
        message: 'username is required to signUp',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.CustomAuthSignInPassword */ .X.CustomAuthSignInPassword]: {
        message: 'A password is not needed when signing in with CUSTOM_WITHOUT_SRP',
        recoverySuggestion: 'Do not include a password in your signIn call.',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.IncorrectMFAMethod */ .X.IncorrectMFAMethod]: {
        message: 'Incorrect MFA method was chosen. It should be either SMS or TOTP',
        recoverySuggestion: 'Try to pass TOTP or SMS as the challengeResponse',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyVerifyTOTPSetupCode */ .X.EmptyVerifyTOTPSetupCode]: {
        message: 'code is required to verifyTotpSetup',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyUpdatePassword */ .X.EmptyUpdatePassword]: {
        message: 'oldPassword and newPassword are required to changePassword',
    },
    [_errors_types_validation_mjs__WEBPACK_IMPORTED_MODULE_0__/* .AuthValidationErrorCode.EmptyConfirmUserAttributeCode */ .X.EmptyConfirmUserAttributeCode]: {
        message: 'confirmation code is required to confirmUserAttribute',
    },
};
// TODO: delete this code when the Auth class is removed.
var AuthErrorStrings;
(function (AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
    AuthErrorStrings["AUTOSIGNIN_ERROR"] = "Please use your credentials to sign in";
    AuthErrorStrings["OAUTH_ERROR"] = "Couldn't finish OAuth flow, check your User Pool HostedUI settings";
})(AuthErrorStrings || (AuthErrorStrings = {}));
var AuthErrorCodes;
(function (AuthErrorCodes) {
    AuthErrorCodes["SignInException"] = "SignInException";
    AuthErrorCodes["OAuthSignInError"] = "OAuthSignInException";
})(AuthErrorCodes || (AuthErrorCodes = {}));


//# sourceMappingURL=AuthErrorStrings.mjs.map


/***/ }),

/***/ 55227:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ AuthValidationErrorCode; }
/* harmony export */ });
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var AuthValidationErrorCode;
(function (AuthValidationErrorCode) {
    AuthValidationErrorCode["EmptySignInUsername"] = "EmptySignInUsername";
    AuthValidationErrorCode["EmptySignInPassword"] = "EmptySignInPassword";
    AuthValidationErrorCode["CustomAuthSignInPassword"] = "CustomAuthSignInPassword";
    AuthValidationErrorCode["EmptySignUpUsername"] = "EmptySignUpUsername";
    AuthValidationErrorCode["EmptySignUpPassword"] = "EmptySignUpPassword";
    AuthValidationErrorCode["EmptyConfirmSignUpUsername"] = "EmptyConfirmSignUpUsername";
    AuthValidationErrorCode["EmptyConfirmSignUpCode"] = "EmptyConfirmSignUpCode";
    AuthValidationErrorCode["EmptyResendSignUpCodeUsername"] = "EmptyresendSignUpCodeUsername";
    AuthValidationErrorCode["EmptyChallengeResponse"] = "EmptyChallengeResponse";
    AuthValidationErrorCode["EmptyConfirmResetPasswordUsername"] = "EmptyConfirmResetPasswordUsername";
    AuthValidationErrorCode["EmptyConfirmResetPasswordNewPassword"] = "EmptyConfirmResetPasswordNewPassword";
    AuthValidationErrorCode["EmptyConfirmResetPasswordConfirmationCode"] = "EmptyConfirmResetPasswordConfirmationCode";
    AuthValidationErrorCode["EmptyResetPasswordUsername"] = "EmptyResetPasswordUsername";
    AuthValidationErrorCode["EmptyVerifyTOTPSetupCode"] = "EmptyVerifyTOTPSetupCode";
    AuthValidationErrorCode["EmptyConfirmUserAttributeCode"] = "EmptyConfirmUserAttributeCode";
    AuthValidationErrorCode["IncorrectMFAMethod"] = "IncorrectMFAMethod";
    AuthValidationErrorCode["EmptyUpdatePassword"] = "EmptyUpdatePassword";
})(AuthValidationErrorCode || (AuthValidationErrorCode = {}));


//# sourceMappingURL=validation.mjs.map


/***/ })

}]);